import {useEffect} from 'react';
import {useLocation} from 'react-router';

const noop = () => {};

export const usePageViews = (callback: (param?) => void = noop) => {
    const location = useLocation();

    useEffect(() => {
        callback(location.pathname);
    }, [location.pathname]);

    return location ? location.pathname : null;
};

export default usePageViews;
